import React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

import clientOptions from "./clientOptions";
import { useTranslation } from "react-i18next";

function ClientMenu({ open, handleClose, client, handleOptionClick }) {
  const { t } = useTranslation();
  const titles = {
    makeActive: t("navigation.clients.makeActive"),
    makeUnActive: t("navigation.clients.makeUnActive"),
    initials: t("navigation.clients.initials"),
    testDevice: t("navigation.clients.testDevice"),
  };
  return (
    <div>
      <Menu
        id="menu-clients-options"
        anchorEl={open}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        disableScrollLock={true}
        open={Boolean(open)}
        onClose={handleClose}
      >
        {clientOptions(client).map((option) => (
          <MenuItem key={option.id} onClick={() => handleOptionClick(option)}>
            <List dense={true} style={{ margin: "0", padding: "0" }}>
              <ListItem style={{ margin: "0", padding: "0" }}>
                <ListItemIcon style={{ minWidth: 36 }}>
                  {<option.icon />}
                </ListItemIcon>

                <ListItemText primary={titles[option.id]} />
              </ListItem>
            </List>
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}

export default ClientMenu;
